// Dependencies
import React from "react";
import { Route, Switch, Redirect, withRouter } from "react-router-dom";

import {
  BackImage,
  BadgeView,
  BookingFormView,
  CheckLogin,
  CollectionView,
  ContactView,
  DashboardView,
  DiplomaView,
  DirectoryView,
  ExhibitionView,
  FastFactsView,
  FavoriteView,
  Header,
  HomeView,
  MessageCenter,
  MobileWarning,
  NotFoundView,
  NotLoggedInView,
  ProfileImageView,
  RewardsView,
  RetainContentView,
  RetainView,
  Search,
  ShowcaseCollectionView,
  ShowcaseCollectionCountryView,
  SubAppView,
  TermsAndConditionsView,
  ThankYouView,
  ToolboxView,
  TrainingContentView,
  TrainingView,
  WebsiteSplitter,
} from "C4";
import { shouldShowMobileWarning } from "helpers/mobile";

const loginPages = ["training", "retain", "rewards", "profile-image"];
const paths = `(${loginPages.join("|")})`;

const SubRouter = () => (
  <div className="subRouter" id="container">
    <Route path={`/main/${paths}`} render={() => <CheckLogin />} />
    <Route
      path="/main/"
      render={(routerProps) => {
        const { pathname } = routerProps.location;
        if (pathname.includes("main/training/chapter/")) {
          return null;
        }
        if (pathname.includes("main/fasttrack/chapter/")) {
          return null;
        }
        if (pathname.includes("main/directory")) {
          return null;
        }
        if (pathname.includes("main/sell/directory")) {
          return null;
        }
        return <Header pathname={pathname} />;
      }}
    />
    <div className="viewContainer">
      <BackImage key={window.location.pathname} />
      <Switch>
        <Route path="/main" exact component={HomeView} />
        <Route path="/main/rewards" exact component={RewardsView} />
        <Route path="/main/rewards/achievements" exact component={BadgeView} />
        <Route path="/main/rewards/dashboard" exact component={DashboardView} />
        <Route path="/main/rewards/form" exact component={BookingFormView} />
        <Route path="/main/rewards/thank-you" exact component={ThankYouView} />
        <Route
          path="/main/rewards/terms"
          exact
          component={TermsAndConditionsView}
        />
        <Route path="/main/landing" exact component={HomeView} />
        <Route path="/main/hotel-showroom" exact component={ExhibitionView} />
        <Route
          path="/main/hotel-showroom/:category/:countryName"
          component={ShowcaseCollectionCountryView}
        />
        <Route
          path="/main/hotel-showroom/:category"
          component={ShowcaseCollectionView}
        />
        <Route path="/main/mob" exact component={MobileWarning} />
        <Route path="/main/promote/contact" exact component={ContactView} />
        <Route path="/main/sell/contact" exact component={ContactView} />
        <Route
          path="/main/(promote|sell)/contact"
          exact
          component={ContactView}
        />
        <Route path="/main/contact" exact component={ContactView} />
        <Route path="/main/diploma" exact component={DiplomaView} />
        <Route path="/main/profile-image" exact component={ProfileImageView} />

        <Route path="/main/training" exact component={TrainingView} />
        <Route path="/main/ret" exact component={RetainView} />
        <Route
          path="/main/ret/chapter"
          exact
          render={() => <Redirect to="/main/ret" />}
        />
        <Route path="/main/retain" exact component={RetainView} />
        <Route
          path="/main/ret/chapter/:chapterId/:pageId"
          exact
          component={RetainContentView}
        />
        <Route
          path="/main/:pageType/chapter/:chapterId/:pageId"
          render={(props) => {
            const { pageType, pageId } = props.match.params;
            switch (pageType) {
              case "ret":
                return <RetainContentView key={pageId} {...props} />;
              case "training":
              case "fasttrack":
                return (
                  <TrainingContentView
                    key={pageId}
                    redirPath={`/main/${pageType}/chapter/`}
                    type={pageType}
                    {...props}
                  />
                );
              default:
                return null;
            }
          }}
        />
        <Route path="/main/favorites" exact component={FavoriteView} />
        <Route path="/main/promote" exact component={FastFactsView} />
        <Route path="/main/sell" exact component={ToolboxView} />
        <Route path="/main/subApp" exact component={SubAppView} />
        <Route path="/main/directory" exact component={DirectoryView} />
        <Route path="/main/sell/directory" exact component={DirectoryView} />
        <Route path="/main/messages" exact component={MessageCenter} />
        <Route path="/main/landing/messages" exact component={MessageCenter} />
        <Route
          path="/main/promote/videos/:videoId?"
          component={CollectionView}
        />
        <Route
          path="/main/promote/images/:imageId?"
          component={CollectionView}
        />
        <Route
          path="/main/sell/videoLibrary/:videoId?"
          component={CollectionView}
        />
        <Route
          path="/main/sell/imageLibrary/:imageId?"
          component={CollectionView}
        />
        <Route
          path="/main/(sell|promote)/:category/:item?"
          component={CollectionView}
        />
        <Route path="/main/offers/:item?" component={CollectionView} />
        <Route path="/main/search" component={Search} />
        <Route path="/main/off" component={NotLoggedInView} />
        <Route
          path="/main/splitter/:itemId/:type"
          component={WebsiteSplitter}
        />
        <Route component={NotFoundView} />
      </Switch>
    </div>
    {/* <Footer /> */}
    {shouldShowMobileWarning() && <MobileWarning />}
  </div>
);

export default withRouter(SubRouter);
